import { AppConfig } from "./app.config";
export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
